module.exports = __webpack_public_path__ + "static/Apercu-LightItalic-fdceaed62ca9de403cbff272f76d0f4e.woff2";